module.exports = __webpack_public_path__ + "assets/img/customer_service.0f65c077.png";